import {
  MdColorLens,
  MdDashboard,
  MdFontDownload,
  MdFormatSize,
  MdImportExport,
  MdInfo,
  MdSettings,
  MdStyle,
  MdVisibility,
} from 'react-icons/md';

export default [
  {
    id: 'templates',
    icon: MdStyle,
  },
  {
    id: 'layout',
    icon: MdDashboard,
  },
  {
    id: 'colors',
    icon: MdColorLens,
  },
  {
    id: 'fonts',
    icon: MdFontDownload,
  },
  {
    id: 'font-size',
    icon: MdFormatSize,
  },
  {
    id: 'actions',
    icon: MdImportExport,
  },
  {
    id: 'settings',
    icon: MdSettings,
  },
  /*
  {
    id: 'about',
    icon: MdInfo,
  },
  */
];
